import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as componentTypes from "../../../constants/componentTypes";
import * as resources from "../../../constants/resources";
import * as methods from "../../../constants/methods";
import * as rccActions from "../../../actions/rccActions";
import * as navigationActions from "../../../actions/navigationActions";
import * as tooltipHelper from "../../../helpers/tooltipHelper";

import Button, {BUTTON_EXTRA_SMALL} from "../generic/Button";

import imgSpectro from "../../../resources/img/svgicons/spectro.svg";

class SpectroMeasureButton extends Component {
    handleStartMeasureClick = () => {
        if (this.props.spectro.dialog === null) {
            this.props.dispatchStartMeasureSpectroAction(this.props.tabId, this.props.callback);
            this.props.dispatchCloseModal();
        }
    };

    render() {
        if (
            this.props.loggedUser.canNotEdit(resources.FUNCTION_SPECTRO_MEASURE) ||
            !this.props.connected ||
            !this.props.spectro.isSelected ||
            !this.props.spectro.isConnected ||
            !this.props.spectro.validMethod(methods.METHOD_SPECTRO_START_MEASURE)
        ) {
            return "";
        }

        if (this.props.size === BUTTON_EXTRA_SMALL) {
            if (!this.props.spectro.isCalibrated) {
                return (
                    <ReactSVG
                        src={imgSpectro}
                        className="size20x20"
                        style={{opacity: 0.4}}
                        data-text={translate("spectroTab.deviceIsNotCalibrated")}
                        onMouseEnter={tooltipHelper.createTooltip}
                    />
                );
            }

            return (
                <ReactSVG
                    src={imgSpectro}
                    className="cursor-pointer size20x20"
                    data-text={translate("spectroTab.measure")}
                    onMouseEnter={tooltipHelper.createTooltip}
                    onClick={this.handleStartMeasureClick}
                />
            );
        }

        if (!this.props.spectro.isCalibrated) {
            return "";
        }

        return (
            <Button
                label={<Translate value="spectroTab.measure" />}
                size={this.props.size ?? null}
                className={this.props.className ?? null}
                svgBefore={imgSpectro}
                onClick={this.handleStartMeasureClick}
                disabled={this.props.spectro.dialog !== null}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        loggedUser: store.login.loggedUser,
        connected: store.rcc.connected,
        spectro: store.spectro.spectro
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchStartMeasureSpectroAction: (tabId, callback) => {
            dispatch(rccActions.startMeasureSpectro(tabId, callback));
        },
        dispatchCloseModal: () => {
            dispatch(navigationActions.closeModal(componentTypes.MATCHING_MEASUREMENT_MODAL));
        }
    };
};

export default SpectroMeasureButton = connect(mapStoreToProps, mapDispatchToProps)(SpectroMeasureButton);
